module.exports = "/_next/static/images/icon-family-39de6c24.png";